import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Vårt val',
  bestPriceBadge: 'Bästa pris',
};
